import { __ } from "@wordpress/i18n";
import { PanelBody, ButtonGroup, Button } from "@wordpress/components";

export default function DisplayTypeControl({ attributes, setAttributes }) {
	const { displayType = "block" } = attributes;

	return (
		<PanelBody title={__("Display Type", "sfb")} initialOpen={true}>
			<ButtonGroup>
				<Button
					variant={displayType === "block" ? "primary" : "secondary"}
					onClick={() => setAttributes({ displayType: "block" })}
				>
					{__("Block", "sfb")}
				</Button>
				<Button
					variant={displayType === "flex" ? "primary" : "secondary"}
					onClick={() => setAttributes({ displayType: "flex" })}
				>
					{__("Flex", "sfb")}
				</Button>
			</ButtonGroup>
		</PanelBody>
	);
}
